<ion-img class="oms-bottom-trademark" [src]="'/assets/images/logo.png'"></ion-img>